exports = module.exports = require("../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CodeMirror-search-match{background:gold;border-top:1px solid orange;border-bottom:1px solid orange;box-sizing:border-box;opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/rt-sd-dnd/~/codemirror/addon/search/matchesonscrollbar.css
// module id = 1595
// module chunks = 1